<template>
    <div>
        <div style="display: flex;justify-content: center;">

            <div style="width: 1200px;">
                <Bread :breads="breads" defaultType="2"></Bread>
                <img src="/static/img/zhuhai/资源检索.svg" alt="">

                <div class="search-form-box" >
                    <el-form :model="searchForm" label-width="auto" style="width:80%;">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="中文名称">
                                    <el-input v-model="searchForm.cname" placeholder="资源中文名称" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="英文名称">
                                    <el-input v-model="searchForm.ename" placeholder="资源英文名称" />
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>

                            <el-col :span="12">
                                <el-form-item label="资源分类">
                                    <el-cascader v-model="searchForm.typeCodes" style="width: 100%;" :options="cascaderOptions" :props="cascaderProps" clearable placeholder="可任意多选" />
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item label="时间范围">
                                    <el-col :span="11">
                                        <el-date-picker
                                            style="width: 100%;"
                                            v-model="searchForm.startTime"
                                            type="date"
                                            placeholder="选择开始时间"
                                        />
                                    </el-col>
                                    <el-col :span="2" class="text-center">
                                        <span class="text-gray-500">-</span>
                                    </el-col>
                                    <el-col :span="11">
                                        <el-date-picker
                                            style="width: 100%;"
                                            v-model="searchForm.endTime"
                                            type="date"
                                            placeholder="选择结束时间"
                                        />
                                    </el-col>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>

                            <el-col :span="12">
                                <el-form-item label="所属机构">
                                    <el-input v-model="searchForm.platformName" placeholder="机构名称" />
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item label="产业领域">
                                    <el-select v-model="searchForm.industrialSector" placeholder="请选择">
                                        <el-option
                                            v-for="item in industrialSectorDictList"
                                            :key="item.id"
                                            :label="item.dictName"
                                            :value="item.dictVal">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>





                    </el-form>
                    <div class="search-button-box">
                        <el-button  v-loading="resLoading" type="primary" :icon="Search" class="res-search-button" @click="getResList">搜索</el-button>
                        <el-button  v-loading="resLoading" :icon="RefreshRight" class="res-refresh-button" @click="cleanSearchForm">清空</el-button>
                    </div>

                </div>


                <div class="res-content-box" >
                    <el-row>
                        <el-col :span="5">
                            <div>
                                <h3 class="text-center">资源分类</h3>


                                <div class="instrument-title">科研仪器</div>
                                <el-scrollbar height="400px" style="border: 1px solid #E7E7E7;" v-loading="typeLoading || resLoading">
                                    <el-tree
                                        :expand-on-click-node="false"
                                        :data="cascaderOptions"
                                        :props="treeProps"
                                        @node-click="(data,node,nodeItem)=>handleNodeClick(data,node,nodeItem)"
                                        accordion
                                    ></el-tree>
                                </el-scrollbar>
                            </div>
                        </el-col>
                        <el-col :span="19" style="padding-left: 20px;" >
                            <div>
                                <p class="instrument-count">共<b style="color: #1EB38A;"> {{ resListResult.total }} </b>个资源</p>


                                <div style="" v-loading="resLoading">
                                    <el-scrollbar style="border: 1px solid #E7E7E7;margin-top: 10px;min-height: 600px;">
                                        <div v-if="resListResult.total > 0" style="display: flex;justify-content: center" v-for="(item,index) in resListResult.list">
                                            <div style="width: 95%;padding: 20px 0px;border-bottom: 1px dashed #E7E7E7;">
                                                <p class="instrument-info-name" @click="gotoDetail(item)">{{ item.cname }}</p>
                                                <div style="margin-top: 10px;">
                                                    <span class="instrument-info-field">更新时间：{{ item.createTime }}</span>
                                                    <span class="instrument-info-field">所属平台：<span style="color: #61CFAF;">{{ item.platformName }}</span></span>
                                                    <span class="instrument-info-field">所属单位：{{ item.unitName }}</span>
                                                </div>
                                                <div>
                                                    <span class="instrument-info-field">安放地市：{{ getCityNameByCodee(item.city) }}</span>
                                                    <span class="instrument-info-field">产业领域：{{ item.industrialSectorStr }}</span>

                                                </div>
                                            </div>

                                        </div>
                                        <el-empty v-else description="暂无数据" />

                                    </el-scrollbar>
                                    <div style="display: flex;justify-content: center;margin-top: 25px;">
                                        <Pager
                                            @pageChange="pageChange"
                                            :layout="'total, prev, pager, next'"
                                            class="res-pager"
                                            :totalRecord="resListResult.total"
                                            :totalPage="resListResult.totalPage"
                                            :currentPage="currentPage"></Pager>

                                    </div>

                                </div>

                            </div>
                        </el-col>
                    </el-row>

                </div>

            </div>


        </div>
    </div>
</template>

<script setup >

import {ref, toRefs, reactive, getCurrentInstance, onMounted} from 'vue'
import { Search,RefreshRight } from '@element-plus/icons-vue'
import Bread from "@/components/common/Bread.vue";
import {useRoute} from "vue-router";
import city from '../../city'
import Pager from "@/components/common/Pager.vue";
import CommonUtil from "@/utils/common";

const {proxy} = getCurrentInstance();

const breads = ref([
    {text:'首页',  path:'/zhaoqing/index'},
    {text:'科研仪器',  path:'/zhaoqing/zhaoqingResRetrieve'}
])

//仪器目录级联选择器配置项
const cascaderProps = {
    multiple: true,
    checkStrictly: true,
    label: 'catalogName',
    value: 'treeCode',
}

//仪器目录级联选择器数据目录
const cascaderOptions = ref([])

const typeLoading = ref(false)

//查询仪器目录
const getCatalogTree = () => {
    typeLoading.value = true;
    proxy.$http.post('/gdsti2/web/a/webResource/catalogTree.do?isOpen=ALL&catalogType=INSTRUMENT_DATA').then(res => {
        if (res.data.state === 0) {
            cascaderOptions.value = res.data.result;
        }
        typeLoading.value = false;
    }).catch(err => {
        typeLoading.value = false;
    });
}

const gotoDetail = (item) => {
    let param = {
        id: item.id,
        catalogType: item.catalogType
    }
    proxy.$router.push({path: '/zhaoqing/zhaoqingInstrumentInfo', query: param})
}


//城市选择
const areaOptions = ref(city.cityList);

const getCityNameByCodee = (code) => {
    for (let i = 0; i < areaOptions.value.length; i++) {
        if (areaOptions.value[i].code === code) {
            return areaOptions.value[i].value;
        }
    }
}

//搜索框表单
const searchForm = reactive({
    cname: '',
    ename: '',
    startTime: '',
    endTime: '',
    area: '',
    typeCodes: [],
    platformName: '',
    catalogTreeCode: '',
    catalogType: 'INSTRUMENT_DATA',
    industrialSector: '',
})

//清空搜索框
const cleanSearchForm = () => {
    searchForm.cname = '';
    searchForm.ename = '';
    searchForm.startTime = '';
    searchForm.endTime = '';
    searchForm.area = '';
    searchForm.typeCodes = [];
    searchForm.platformName = '';
    searchForm.industrialSector = '';
    getResList();
}

//树节点点击
const handleNodeClick = (data,node,nodeItem) => {
    searchForm.typeCodes = [data.treeCode];
    getResList();
}

//资源目录树节点配置
const treeProps = {
    children: 'children',
    label: 'catalogName',
    value: 'id'
}

//资源查询结果
const resListResult = ref({})

const resLoading = ref(false);


//页码
const currentPage = ref(1)

//查询仪器数据
const getResList = () => {
    resLoading.value = true;

    searchForm.catalogTreeCode = searchForm.typeCodes.join(',');

    searchForm.limit = 10;
    searchForm.offset = (currentPage.value-1)*10;

    proxy.$http.post('/gdsti2/web/a/webResource/resourceDataList',searchForm).then(res => {
        if (res.data.state == 0) {
            if(res.data.state === 0){
                resListResult.value = res.data.result;
            }
        }
        resLoading.value = false;
    }).catch(err => {
        resLoading.value = false;
    });
}


const pageChange = (index) => {
    currentPage.value = index;
    getResList();
}

const industrialSectorDictList = ref([]);

const route = useRoute();
onMounted( async ()=>{

    industrialSectorDictList.value = await CommonUtil.loadDataDictList('RES_INSTRUMENT_ZHUHAI_INDUSTRIAL_SECTOR')


    if(route.query && route.query.searchText){
        searchForm.cname = route.query.searchText;
    }
    if(route.query && route.query.typeCode){
        searchForm.typeCodes.push(route.query.typeCode);
    }

    if(route.query && route.query.industrialSector){
        searchForm.industrialSector = route.query.industrialSector;
    }
    getCatalogTree();
    getResList();
});


</script>

<style lang="less" scoped>

#index-title{


    font-family: DingTalk JinBuTi;
    font-size: 36px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0em;

    //font-variation-settings: "opsz" auto;
    font-feature-settings: "kern" on;
    color: #FFFFFF;

    text-shadow: 0px 2px 3px #0037A5;

}

/deep/ .el-form-item__label{
    color: black;
}
/deep/ .el-form-item{
    margin-bottom: 15px;
}
/deep/ .el-form-item__label-wrap{
    margin-left: 15px;
}
.text-center{
    text-align: center;
}
.res-search-button{
    width: 60%;
    margin: 0px;
    background-color: #1EB38A;
}
.res-refresh-button{
    width: 60%;
    margin: 0px;
    color: #1EB38A;
    border: 2px solid #1EB38A;
}
.search-button-box{
    width: 20%;
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: center;
}
.search-form-box{
    background-color: white;
    display: flex;
    padding-top: 15px;
    border-radius: 10px;
}

.res-content-box{
    background: linear-gradient(180deg, #FFFFFF 0%, #F6F9FF 100%);
    background-size: 100% 600px;
    background-repeat: no-repeat;
    margin-top: 25px;
    padding: 15px 20px;
    border-radius: 10px;
}

.instrument-title{
    background-color: #1EB38A;
    color: white;
    height: 40px;
    font-size: 18px;
    display:flex;
    align-items: flex-end;
    padding: 5px 15px;
}

.instrument-info-name{
    font-family: 思源黑体;
    font-size: 18px;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0px;
    color: #61CFAF;
}
.instrument-info-name:hover{
    cursor: pointer;
}
.instrument-info-field{
    font-family: 思源黑体;
    font-size: 14px;
    font-weight: normal;
    line-height: normal;
    color: rgba(0, 0, 0, 0.85);
    margin-right: 27px;
}
.instrument-count{
    font-family: 思源黑体;
    font-size: 20px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0px;
}

</style>

